import Vue from 'vue'
import Router from 'vue-router'
import baseRoutes from './base'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: baseRoutes
})

export default router
